<template>

  <b-navbar toggleable="sm"  class="p-0" fixed="top">
    <b-container>
      <b-navbar-brand :to="{name: 'Home'}">
        <img class="logo-wrap" src="../assets/nav/WHIN_logo.svg" alt="WHIN">
      </b-navbar-brand>

      <b-collapse is-nav id="main-nav">
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="https://whin.org/about">About</b-nav-item>
          <b-nav-item href="https://whin.org/rcf" active>RCF</b-nav-item>
          <b-nav-item href="https://whin.org/team">Team</b-nav-item>
          <b-nav-item href="https://whin.org/news">News</b-nav-item>
          <b-nav-item href="https://whin.org/resources">Resources</b-nav-item>
          <b-nav-item href="https://whin.org/alliances">Alliances</b-nav-item>
        </b-navbar-nav>
      </b-collapse>

      <b-nav-toggle target="main-nav" class="ml-auto"></b-nav-toggle>

  </b-container>
  </b-navbar>
</template>

<script>
  import "../assets/fonts/aeromatics/stylesheet.css";
  export default {
    name: "WhinNavbar"
  }
</script>

<style scoped>
  .navbar {
    background-color: rgba(255,255,255,0.95);
    /*box-shadow: 2px 0 10px;*/
    min-height: 4rem;
    border-bottom: 1px solid rgba(32, 32, 32, 0.1);
    margin-top: .5rem;
  }
  .navbar .nav-link {
    color: #999;
    font-family: "aero_maticsregular", Arial, sans-serif;
    font-weight: normal;
    font-size: 1rem;
    text-transform: uppercase;
    margin: 0 1rem;
    padding: 0.25rem 1rem;

    letter-spacing: 0.5px;
    border-radius: 3px;
    border-bottom: 1px solid transparent;
  }
  .navbar .nav-link:hover {
    color: #000;
    border-bottom: 1px solid #00bdaa;
  }

  .nav-link.active {
    background-color: #777;
    color: white !important;
  }
  .logo-wrap {
    width: 125px;
    margin-left: -10px;
  }
  @media (max-width: 600px) {
    .logo-wrap {
      width: 300px;
      height: 20px;
    }
  }
</style>